import { Tag } from "@blueprintjs/core"
import { Tooltip2 } from "@blueprintjs/popover2"
import CustomButton from "components/Atoms/CustomButton"
import Divider from "components/Atoms/Divider"
import Duration from "components/Atoms/Duration"
import {
  Content,
  ProgressStep,
  ProgressStepsWrapper,
  Title,
} from "components/Molecules/ProgressSteps"
import dayjs from "dayjs"
import { BeatDetailQuery } from "generated/graphql"
import React from "react"
import { useSearchParams } from "react-router-dom"

// const outlets = times(15, time => {
//   return {
//     id: time,
//     name: `Outlet ${time}`,
//     doneAt: sample([new Date().toISOString(), null]),
//     timeTaken: sample([8, 15, 20, 25]),
//   }
// })

type BeatTrackingTimelineProps = {
  outlets: BeatDetailQuery["beatDetail"]["assignment"]["assignedRoutePoints"]
}
const BeatTrackingTimeline = ({ outlets }: BeatTrackingTimelineProps) => {
  const [, setParams] = useSearchParams()
  return (
    <ProgressStepsWrapper vertical={true}>
      {outlets?.map(outlet => {
        const isCompleted = outlet.visitByBeat ? true : false
        const dateObj = outlet.visitByBeat?.endTime
          ? dayjs(outlet.visitByBeat?.endTime)
          : null
        const duration = outlet.visitByBeat?.duration

        return (
          <ProgressStep
            sequenceId={outlet.sequence}
            key={outlet.id}
            done={isCompleted}
            intent={isCompleted ? "success" : undefined}
            lineStyle={isCompleted ? null : "dashed"}
          >
            <Title className="flex items-center justify-between">
              <h6 className="m-0">{outlet.visitee.fullName}</h6>
              {dateObj && (
                <Tooltip2
                  className="font-sm p-1"
                  content={dateObj.format("dddd, Do MMM YYYY hh:mm a")}
                >
                  <Tag intent="primary" minimal>
                    {dateObj.format("hh:mm a")}
                  </Tag>
                </Tooltip2>
              )}
            </Title>
            <Content className="mb-3">
              <Divider dashed className="my-2" />
              <span>
                Time Spent : <Duration duration={duration} />
              </span>
              <div className="mt-2 flex justify-end">
                <CustomButton
                  disabled={!outlet.visitByBeat?.id}
                  onClick={() => {
                    if (outlet.visitByBeat?.id) {
                      setParams({
                        visit: outlet.visitByBeat?.id.toString(),
                        name: outlet.visitee.fullName,
                      })
                    }
                  }}
                  minimal
                  intent="primary"
                >
                  Visit Details
                </CustomButton>
              </div>
            </Content>
          </ProgressStep>
        )
      })}
    </ProgressStepsWrapper>
  )
}

export default BeatTrackingTimeline
